/**
 *    Mam - Exposed filter
 */

(function ($) {
  Drupal.behaviors.exposedFilter = {
    attach() {
      const $form = $('form#views-exposed-form-mam-terms-page-term');
      // The search needs a comma-separated list of values
      // so we have to join the selected values and store them
      // in a hidden field that will then be submitted instead of the select box values.

      $form.find('select').each(function () {
        const $select = $(this);
        const $hiddenInput = $('<input type="hidden"/>');

        $hiddenInput.attr('name', $select.attr('name'));
        $select.attr('name', null);

        $form.append($hiddenInput);

        $select.on('change', () => {
          const values = [];

          $select.find(':selected').each(function () {
            values.push($(this).attr('value'));
          });
          $hiddenInput.val(values.join(','));
        });
      });
    },
  };
}(jQuery));

// end of mam--exposed-filter.js
